import styled from '@emotion/styled';
import { SCREEN_MASSIVE } from '../../styles/emotion/mediaQuery';
import { MEDIA_QUERY, SPACING, FONT } from '../../styles/emotion';
import COLORS from '../../styles/emotion/colors3';

export const Container = styled.div`
  padding: ${SPACING.XS};

  ${MEDIA_QUERY.EXCLUDE_MOBILE_XS} {
    padding: ${SPACING.S16};
  }

  border-bottom: var(--border-grid, 1px solid ${COLORS.BLACK_030});
  max-width: ${SCREEN_MASSIVE}px;
`;
export const ValuesWrapper = styled.div<{ backgroundColor?: string; fontColor?: string }>`
  display: flex;
  border-radius: var(--border-radius-md, 16px);
  align-items: center;
  flex-direction: column;
  min-height: 292px;
  justify-content: center;
  padding: ${SPACING.S24} 0;

  ${MEDIA_QUERY.TABLET} {
    min-height: 388px;
  }

  ${MEDIA_QUERY.DESKTOP} {
    padding: 0;
    min-height: 244px;
    flex-direction: row;
    justify-content: space-around;
  }

  ${MEDIA_QUERY.DESKTOP_XL} {
    min-height: 344px;
  }

  ${(props) =>
    props.backgroundColor &&
    `
    background-color: ${props.backgroundColor}
  `};

  ${(props) =>
    props.fontColor &&
    `
    h2 {
      color: ${props.fontColor}
    }

    hr {
      border-color: ${props.fontColor};
    }

  `};

  h2 {
    text-align: center;
    justify-self: center;

    ${MEDIA_QUERY.DESKTOP} {
      max-width: 350px;
      margin: 0 ${SPACING.LG};
    }
    ${MEDIA_QUERY.DESKTOP_LG} {
      max-width: 405px;
      font-size: ${FONT.FONT_SIZE_LARGER};
    }

    ${MEDIA_QUERY.DESKTOP_XL} {
      max-width: 405px;
      font-size: ${FONT.FONT_SIZE_SEMI_HUGE};
    }

    ${MEDIA_QUERY.MOBILE} {
      font-size: ${FONT.FONT_SIZE_REGULAR};
      max-width: 200px;
    }
    ${MEDIA_QUERY.TABLET} {
      font-size: ${FONT.FONT_SIZE_LARGER};
      max-width: 460px;
    }
  }

  hr {
    align-self: normal;
    border-left: none;
    border-right-width: 1px;

    margin: ${SPACING.S24} ${SPACING.S16};

    ${MEDIA_QUERY.TABLET} {
      margin: ${SPACING.S32} ${SPACING.LG};
    }
    ${MEDIA_QUERY.DESKTOP} {
      margin: ${SPACING.S16} 0;
    }
  }
`;
